import { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";

import type { PillowValuePropsContainer as PillowValuePropsContainerValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

type IProps = Immutable<{ value: PillowValuePropsContainerValue }>;

export const PillowValuePropsContainer = (props: IProps): React.JSX.Element => {
    return (
        <div
            className={concatClassNames([
                styles.pillowValuePropsContainer,
                getGlobalSpacingClasses(props.value.spacing),
            ])}
        >
            <div className={styles.pillowValuePropsContainerTitle}>
                <h1>{props.value.title}</h1>
            </div>
            <div
                className={styles.pillowValuePropsContainerSubtitle}
                dangerouslySetInnerHTML={{
                    __html: props.value.subtitle ?? "",
                }}
            ></div>
            <ul className={styles.pillowValuePropsContainerPropsList}>
                {(props.value.value_props ?? []).map((prop, index) => (
                    <React.Fragment key={index}>
                        <li>
                            <div
                                className={
                                    styles.pillowValuePropsContainerPropHeader
                                }
                            >
                                {prop.header}
                            </div>
                            <div
                                className={
                                    styles.pillowValuePropsContainerPropCopy
                                }
                                dangerouslySetInnerHTML={{
                                    __html: prop.copy ?? "",
                                }}
                            ></div>
                        </li>
                        <div
                            className={
                                styles.pillowValuePropsContainerPropDivider
                            }
                        ></div>
                    </React.Fragment>
                ))}
            </ul>
            <div className={styles.pillowValuePropsContainerImage}>
                <img
                    src={props.value.image?.url}
                    alt="Cocoon by Sealy Pillow"
                    loading="lazy"
                    decoding="async"
                />
            </div>
        </div>
    );
};
